import { ColumnDef } from "@tanstack/react-table";
import { AxiosError, AxiosResponse } from "axios";
import React, { useEffect, useState,  useRef} from "react";
import DataTable2 from "shared/DataTable2";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion"
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/Label";
import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import { Option } from "../../interface/Option";
import { Result, DragAgeGender } from "../../interface/DragAgeAndGender";
import { DragAgeGenderAxiosInstance } from "../../Network/DragAgeGenderAxiosInstance";
import ListOfDrugCode from "../Shared/DrugCode";
import ListOfDrugMedical from "../Shared/DrugMedicalGroup";
import ListOfDrugCustom from "../Shared/DrugCustomGroup";
import ListOfNewNetworkName from "../Shared/NewNetworkName"
import ListOfInsuranceplanName from "../Shared/ListOfInsuranceplanName";
import Patient from "../Shared/Patient"
import ListOfProviderName from "../Shared/ListOfProviderName"
import PolicyNames from "../Shared/PolicyNames";
const DragAgeAndGender: React.FC = () => {
  // Main data state
  const [items, setItems] = useState<DragAgeGender>({ result: [] });

// Form states
  const [gender, setGender] = useState<string>("male");
   const [customGroupName, setCustomGroupName] = useState<string>("");
 const [customDrugGroups, setCustomDrugGroups] = useState<Option[]>([]);
 const [medicalDrugGroups, setMedicalDrugGroups] = useState<Option[]>([]);
 const [DrugCode, setDrugCode] = useState<Option[]>([]);
 const [provider, setProvider] = useState<Option[]>([]);
 const [applyToOtherProviders, setApplyToOtherProviders] =useState<boolean>(false);
 const [networks, setNetworks] = useState<Option[]>([]);
 const [apply_to_other_networks, setApply_to_other_networks] =useState<boolean>(false);
 const [insuranceplan, setInsuranceplan] = useState<Option[]>([]);
 const [apply_to_other_insuranceplan, setapply_to_other_insuranceplan] =useState<boolean>(false);
 const [Payer, setPayer] = useState<string[]>([]);
 const [apply_to_other_payer, setapply_to_other_payer] =useState<boolean>(false);
const [policy, setPolicy] = useState<Option[]>([]);
 const [apply_to_other_policy, setApply_to_other_policy] =useState<boolean>(false);
 const [userLevel, setUserLevel] = useState<string[]>([]);
 const [apply_to_other_user, setApply_to_other_user] =useState<boolean>(false);
 const [patients, setPatients] = useState<Option[]>([]);
 const [apply_to_other_patients, setApply_to_other_patients] =useState<boolean>(false);
 const [apply_to_other_vip, setApply_to_other_vip] =useState<boolean>(false);
 const [Age, setAge] =  useState<number|null >(null);
 const [lowerAge, setLowerAge] =  useState<number|null >(null);
 const [higherAge, setHigherAge] =  useState<number|null >(null);
 const [ageExclude, setAgeExclude] = useState<boolean>(true);
 // UI control states
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [clearDrugCode, setClearDrugCode] = useState(false);
   const [clearCustomDrugGroups ,setClearCustomDrugGroups] = useState(false);
    const [clearMedicalDrugGroups ,setClearMedicalDrugGroups] = useState(false);
  const [clearNetworks, setClearNetworks] = useState(false);
  const [clearInsuranceplan, setClearInsuranceplan] = useState(false);
  const [clearProvider, setClearProvider] = useState(false);
 const [clearPatient, setClearPatient] = useState(false);
const [clearPolicy, setClearPolicy] = useState(false);
  

   // dialog for details
    const [selectedItem, setSelectedItem] = useState<Result | null>(null);
     const dialogRef = useRef<HTMLDialogElement | null>(null);
// Get token from localStorage
  const token = localStorage.getItem("token") || "";
  // Initialize toast
  const { toast } = useToast();

  // Fetch initial data on component mount
  useEffect(() => {
    fetchItems();
}, []);

// Clear form function
  const clear = () => {
     setGender("");
    setCustomGroupName("");
    setDrugCode([]);
    setCustomDrugGroups([]);
    setMedicalDrugGroups([]);
    setLowerAge(null);
    setHigherAge(null);
    setAgeExclude(true);
    setProvider([]);
    setApplyToOtherProviders(false);
    setNetworks([]);
    setApply_to_other_networks(false);
    setInsuranceplan([]);
    setapply_to_other_insuranceplan(false);
    setPayer([]);
    setapply_to_other_payer(false);
    setPatients([]);
   setApply_to_other_patients(false);
   setApply_to_other_vip(false);
 setApply_to_other_policy(false);
   setApply_to_other_user(false);
   setPolicy([]);
   setUserLevel([]);
  setAge(null);
};

// Dialog details control handlers
const handleOpenDialog = (item: Result) => {
  setSelectedItem(item);
  dialogRef.current?.showModal(); 
};

const handleCloseDialog = () => {
  dialogRef.current?.close();
  setSelectedItem(null);
};


  // Dialog control handlers
  const handleAddClick = () => {
    setEditIndex(null);
    clear();
    setIsDialogOpen(true); }

  const handleEditClick = (item: Result) => {
    handleEdit(item);
    setIsDialogOpen(true); }


    // Handlers for form inputs 
 const handleRelatedDrugChange = (selectedOptions: Option[]) => {
           console.log("selected:", selectedOptions);
           setDrugCode(selectedOptions);
         };
const handleCustomDrugGroupsChange = (selectedOptions: Option[]) => {
          console.log("selected:", selectedOptions);
          setCustomDrugGroups(selectedOptions);
        };
    
  const handleMedicalDrugGroupsChange = (selectedOptions: Option[]) => {
          console.log("selected:", selectedOptions);
          setMedicalDrugGroups(selectedOptions);
        };
    const handleNetworksChange = (selectedOptions: Option | Option[] | null) => {
            console.log("Selected networks:", selectedOptions);
          
            if (!selectedOptions) {
              setNetworks([]); // If nothing is selected, make it an empty array
              return;
            }
          
         // If the value is only one object, put it inside an array
            setNetworks(Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions]);
          };
       
      const handleInsurancePlanChange = (selectedOptions: Option[]) => {
          console.log("selected:", selectedOptions);
          setInsuranceplan(selectedOptions);
        }
        const handlePoliciesChange = (selectedOptions: Option[]) => {
                     setPolicy(selectedOptions);
                      };
                 const handlePatientChange = (selectedOptions: Option[]) => {
                    setPatients(selectedOptions);
                                    };

               const handleProviderChange = (selectedOptions: Option[]) => {
                        setProvider(selectedOptions);
                            };
  


       // API Functions
          const fetchItems = async (): Promise<void> => {
            try {
              const response: AxiosResponse<{ success: boolean; result: Result[] }> =
                await DragAgeGenderAxiosInstance.get("getDrugsagetogender");
              setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

              console.log(response.data.result);
            } catch (error) {
              console.error("Error fetching items:", error);
              toast({
                title: "Error",
                description: "Failed to fetch Relation Drug Age And Gender",
                variant: "destructive",
              });
            }
          };
        

  const addItem = async (): Promise<void> => {
    if (!customGroupName.trim() ) {
      toast({
        title: "Error",
        description: " Group Name is required and cannot be empty.",
        variant: "destructive",
      });
      return;
    }
    if (customGroupName.trim().length < 3 ) {
      toast({
        title: "Error",
        description: " Group Name must be at least 3 characters long.",
        variant: "destructive",
      });
      return;
    }
    const ValuesDrugMedical = medicalDrugGroups.map((option) => option.value);
    const ValuesDrugCustom = customDrugGroups.map((option) => option.value);
    const ValuesDrugcode = DrugCode.map((option) => option.value);
     const ValuesNetwork = networks.map((option) => option.value);
     const ValuesInsurancePlan = insuranceplan.map((option) => option.value);
        const ValuesPolicy = policy.map((option) => option.value);
  const ValuesPatient = patients.map((option) => option.value);
  const ValuesProvider = provider.map((option) => option.value);
    try {
      
      const newGroupArray = 
        {
          gender: gender,
          relation_name: customGroupName,
          drugs:ValuesDrugcode,
          medical_drug_groups:ValuesDrugMedical,
          custom_drug_groups:ValuesDrugCustom,
          lower_age: lowerAge,
          higher_age: higherAge,
          age_exclude: ageExclude,
            provider: ValuesProvider,
            apply_to_other_providers: applyToOtherProviders,
            networks:ValuesNetwork,
           apply_to_other_networks:  apply_to_other_networks ,
           insuranceplan:ValuesInsurancePlan,
            apply_to_other_insuranceplan:apply_to_other_insuranceplan,
           payer:Payer,
            apply_to_other_payer:apply_to_other_payer,
            patients:ValuesPatient,
            apply_to_other_patients:apply_to_other_patients,
            policy:ValuesPolicy,
            apply_to_other_policy:apply_to_other_policy,
            user_level:userLevel,
            apply_to_other_user:apply_to_other_user,
            apply_to_vip:apply_to_other_vip,
      
          token: token,
        
        }
      
      console.log("newGroupArray", newGroupArray);

      const response = await DragAgeGenderAxiosInstance.post(
        "addNewDrugsagetogender", newGroupArray
           );
  
      if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);
  
        toast({
          title: "Success",
          description: "New Relation Drug Age And Gender Added Successfully.",
        });
      } else {
                const errors = response.data.errors || [];
                const errorMessages = errors.map((error: any) => error.error).join("\n"); 
            
                toast({
                  title: "Error",
                  description: errorMessages || response.data.message || "Failed to add the group.",
                  variant: "destructive",
                });
            
                console.log(errors);
              }
            } catch (error: AxiosError | any) {
              toast({
                title: "Error",
                description:
                  error.response?.data?.error || "An unexpected error occurred.",
                  variant: "destructive",
              });
            }
  };
  

// Handle edit
  const handleEdit = (item: Result) => {
      
    // Convert or process fields Networks
    const networksData = Array.isArray(item.networks)
      ? item.networks.map((obj) =>
          typeof obj === "string"
            ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
            : obj // If the element is an object, use it as is.
        )
      : [];
 
    setNetworks(
      networksData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    const DrugCodes = (item.drugs || []).map((drugs: string) => ({
        label: drugs,
        value: drugs,
      }));
      setDrugCode(DrugCodes);
    //Convert or process Custom Drug Groups fields
    const CustomDrugGroupsData = Array.isArray(item.custom_drug_groups)
    ? item.custom_drug_groups.map((obj) =>
        typeof obj === "string" ? { id: 0, name: obj } : obj
      )
    : [];
    
    setCustomDrugGroups(
    CustomDrugGroupsData.map((obj) => ({
      value: obj.id,
      label: obj.name,
    }))
    );
    //Convert or process medical_Drug_groups fields
    const MedicalDrugGroupsData = Array.isArray(item.medical_drug_groups)
    ? item.medical_drug_groups.map((obj) =>
        typeof obj === "string" ? { id: 0, name: obj } : obj
      )
    : [];
    
    setMedicalDrugGroups(
    MedicalDrugGroupsData.map((obj) => ({
      value: obj.id,
      label: obj.name,
    }))
    );
    //Convert or process insuranceplan fields
    const insuranceplanData = Array.isArray(item.insuranceplan)
      ? item.insuranceplan.map((obj) =>
          typeof obj === "string"
            ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
            : obj // If the element is an object, use it as is.
        )
      : [];
  
    setInsuranceplan(
      insuranceplanData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
 
   // Convert or process fields Providers 
   const ProvidersData = Array.isArray(item.provider)
   ? item.provider.map((obj) =>
       typeof obj === "string"
         ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
         : obj // If the element is an object, use it as is.
     )
   : [];

 setProvider(
   ProvidersData.map((obj) => ({
     value: obj.id,
     label: obj.name,
   }))
 );
 // Convert or process fields Patients
   const PatientsData = Array.isArray(item.patients)
   ? item.patients.map((obj) =>
       typeof obj === "string"
         ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
         : obj // If the element is an object, use it as is.
     )
   : [];

 setPatients(
   PatientsData.map((obj) => ({
     value: obj.id,
     label: obj.name,
   }))
 );
    //Convert or process Policy fields
    const PolicyData = Array.isArray(item.policy)
    ? item.policy.map((obj) =>
        typeof obj === "string"
          ? { id: 0, name: obj } // If the element is text, convert it to a temporary object.
          : obj // If the element is an object, use it as is.
      )
    : [];

    setPolicy(
    PolicyData.map((obj) => ({
      value: obj.id,
      label: obj.name,
    }))
  );

 setApply_to_other_policy(item.apply_to_other_policy);
  setGender(item.gender);
    setCustomGroupName(item.relation_name);
  
    setLowerAge(item.lower_age);
    setHigherAge(item.higher_age);
    setAgeExclude(item.age_exclude);
    setApplyToOtherProviders(item.apply_to_other_providers);
    setApply_to_other_networks(item.apply_to_other_networks);
    setapply_to_other_insuranceplan(item.apply_to_other_insuranceplan);
    setPayer(item.payer);
    setapply_to_other_payer(item.apply_to_other_payer);
    setApply_to_other_patients(item.apply_to_other_patients);
    setApply_to_other_user(item.apply_to_other_user);
    setApply_to_other_vip(item.apply_to_vip);
    setUserLevel(item.user_level);
    setEditIndex(item.id);
  };
  
const updateItem = async (id: string | number): Promise<void> => {
    const ValuesDrugMedical = medicalDrugGroups.map((option) => option.value);
    const ValuesDrugCustom = customDrugGroups.map((option) => option.value);
    const ValuesDrugcode = DrugCode.map((option) => option.value);
  const ValuesNetwork = networks.map((option) => option.value);
  const ValuesInsurancePlan = insuranceplan.map((option) => option.value);
   const ValuesPolicy = policy.map((option) => option.value);
  const ValuesPatient = patients.map((option) => option.value);
  const ValuesProvider = provider.map((option) => option.value);

  if (!customGroupName.trim() ) {
    toast({
      title: "Error",
      description: " Group Name is required and cannot be empty.",
      variant: "destructive",
    });
    return;
  }
  if (customGroupName.trim().length < 3 ) {
    toast({
      title: "Error",
      description: " Group Name must be at least 3 characters long.",
      variant: "destructive",
    });
    return;
  }
    try {
     
       const updatedItem = {
        gender: gender,
        relation_name: customGroupName,
        drugs:ValuesDrugcode,
        medical_drug_groups:ValuesDrugMedical,
        custom_drug_groups:ValuesDrugCustom,
        lower_age: lowerAge,
        higher_age: higherAge,
        age_exclude: ageExclude,
          provider: ValuesProvider,
            apply_to_other_providers: applyToOtherProviders,
            networks:ValuesNetwork,
           apply_to_other_networks:  apply_to_other_networks ,
           insuranceplan:ValuesInsurancePlan,
            apply_to_other_insuranceplan:apply_to_other_insuranceplan,
           payer:Payer,
            apply_to_other_payer:apply_to_other_payer,
            patients:ValuesPatient,
            apply_to_other_patients:apply_to_other_patients,
            policy:ValuesPolicy,
            apply_to_other_policy:apply_to_other_policy,
            user_level:userLevel,
            apply_to_other_user:apply_to_other_user,
            apply_to_vip:apply_to_other_vip,
    
          id: id,
        token: token,
      };
console.log("updatedItem", updatedItem);
      const response = await DragAgeGenderAxiosInstance.put(
        `updateDrugsagetogender`,
        updatedItem
      );

      if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);
        toast({
          title: "Success",
          description: "Relation Drug Age And Gender updated successfully.",
        });
      }
    } catch (error: AxiosError | any) {
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "An unexpected error occurred.",
          variant: "destructive",
      });
    }
  };

  const removeItem = async (id: string | number): Promise<void> => {
    try {
      await   DragAgeGenderAxiosInstance.delete(`deleteDrugsagetogender/${id}`, {
        data: { token: token },
      });
      fetchItems();
      toast({
        title: "Success",
        description: "Relation Drug Age And Gender Deleted Successfully.",
      });
    } catch (error) {
      console.error("Error removing item:", error);
      toast({
        title: "Error",
        description: "Failed to delete Relation Drug Age And Gender",
        variant: "destructive",
      });
    }
  };


  

  // Table Columns Configuration
  const columns: ColumnDef<Result>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc" ? " ↑" : column.getIsSorted() === "desc" ? " ↓" : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const item = row.original;
        return (
          <button onClick={() => handleOpenDialog(item)} className="id-button">
            {item.id}
          </button>
        );
      }},
       
          {
            accessorKey: "relation_name",
            header: ({ column }) => (
              <Button
                variant="ghost"
                onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
              >
                Relation Name
                {column.getIsSorted() === "asc"
                  ? " ↑"
                  : column.getIsSorted() === "desc"
                  ? " ↓"
                  : ""}
              </Button>
            ),
          }, 
      {
        accessorKey: "drugs",
        header: ({ column }) => (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
         Drug Codes
            {column.getIsSorted() === "asc"
              ? " ↑"
              : column.getIsSorted() === "desc"
              ? " ↓"
              : ""}
          </Button>
        ), 
        cell: ({ row }) => {
          const drug = row.getValue("drugs") as string[];
          if (Array.isArray(drug)) {
            const displayeddrug = drug.slice(0, 3);
            return drug.length > 3
              ? `${displayeddrug.join(", ")}...` 
              : displayeddrug.join(", "); 
          }
          return drug;  
        },
        
      },
          {
            accessorKey: "gender",
            header: ({ column }) => (
              <Button
                variant="ghost"
                onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
              >
                Gender
                {column.getIsSorted() === "asc"
                  ? " ↑"
                  : column.getIsSorted() === "desc"
                  ? " ↓"
                  : ""}
              </Button>
            ),
            cell: ({ row }) => {
              const gender = row.getValue("gender") as string;
              if (!gender) return "";
              const normalized = gender.toLowerCase();
              if (normalized === "male") return "Male";
              if (normalized === "female" || normalized === "feamal") return "Female";
              return gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase();
            },
          },
  ];

  return (
    <div className=" h5-container mx-auto p-8">
    <h5 className="mb-6 flex items-center gap-2" style={{fontWeight:"bolder" ,fontSize:"22px",  marginTop:"15px"}}>
    <span className="icon-container">
                    <i className="fa-solid fa-list"></i>
                </span>
      Drug: Age and Gender
        </h5>

      <DataTable2
        columns={columns}
        data={items.result}
        searchColumns={["relation_name"]}
        addButtonLabel="Add New Relation "
          validateButtonLabel="Validate"
        showAddButton={true}
        onEdit={handleEdit}
        onDelete={removeItem}
        onAdd={handleAddClick}
        onEditClick={handleEditClick}
      />
    
  {Boolean(selectedItem) &&(
                
                  
                    <dialog ref={dialogRef} className="custom-dialog" open>
                        {selectedItem && (
                            <div className="dialog-content">
                                {/* top-dialog-close-icon */}
                                <button className="dialog-close-icon" onClick={handleCloseDialog}>
                                    ×
                                </button>

                                {/* dialog-title */}
                                <h2 className="dialog-title">
                                    <span>Details for ID:</span> {selectedItem.id}
                                </h2>

                                {/* Content */}
                                <div className="dialog-grid">
                                    <div className="dialog-row two-col-row">
                                        <div className="dialog-item">
                                            <strong>Relation Name:</strong> <span>{selectedItem.relation_name}</span>
                                        </div>
                                        <div className="dialog-item">
                                        <strong>Gender:</strong>
                                   <p>{selectedItem.gender === "male" ? "Male" : selectedItem.gender === "female" || selectedItem.gender === "feamal" ? "Female" : selectedItem.gender}</p>
                                      </div>
                                    </div>
                                    <div className="dialog-row three-col-row">
                                        <div className="dialog-item">
                                            <strong>Drugs:</strong>
                                            <p>{selectedItem.drugs.join(", ")}</p>
                                        </div>
                                        <div className="dialog-item">
                                            <strong>Medical Drug Groups:</strong>
                                            <p>{selectedItem.medical_drug_groups.map(n => n.name).join(", ")}</p>
                                        </div>
                                        <div className="dialog-item">
                                            <strong>Custom Drug Groups:</strong>
                                            <p>{selectedItem.custom_drug_groups.map(n => n.name).join(", ")}</p>
                                        </div>
                                    </div>
                                    <div className="dialog-row three-col-row">
                                        <div className="dialog-item">
                                            <strong>Lower Age:</strong>
                                            <p>{selectedItem.lower_age}</p>
                                        </div>
                                        <div className="dialog-item">
                                            <strong>Higher Age:</strong>
                                            <p>{selectedItem.higher_age}</p>
                                        </div>
                                        <div className="dialog-item">
                                            <strong>Age Exclude:</strong>
                                            <p>{String(selectedItem.age_exclude)}</p>
                                        </div>
                                    </div>
                                    <div className="dialog-row two-col-row">
                                        <div className="dialog-item">
                                            <strong>Networks:</strong> <span>{selectedItem.networks.map(n => n.name).join(", ")}</span>
                                            <strong className="ml-6"> Apply TO Other Networks:</strong> <span>{String(selectedItem.apply_to_other_networks)}</span>
                                        </div>
                                        <div className="dialog-item">
                                            <strong>Insurance Plan:</strong> <span>{selectedItem.insuranceplan.map(n => n.name).join(", ")}</span>
                                            <strong className="ml-6"> Apply To Other Insurance Plan :</strong> <span>{String(selectedItem.apply_to_other_insuranceplan)}</span>
                                        </div>
                                    </div>
                                    <div className="dialog-row two-col-row">
          <div className="dialog-item">
              <strong>Payers:</strong> <span>{selectedItem.payer.join(", ")}</span>
              <strong className="ml-6"> Apply To Other Payers:</strong> <span>{String(selectedItem.apply_to_other_payer)}</span>
            </div>
            <div className="dialog-item">
              <strong>Provider:</strong> <span>{selectedItem.provider.map(n => n.name).join(", ")}</span>
              <strong className="ml-6"> Apply To Other Provider:</strong> <span>{String(selectedItem.apply_to_other_providers)}</span>
            </div>
           </div>
          <div className="dialog-row two-col-row">
            <div className="dialog-item">
              <strong>Policy:</strong> <span>{selectedItem.policy.map(n => n.name).join(", ")}</span>
              <strong className="ml-6"> Apply To Other Policy:</strong> <span>{String(selectedItem.apply_to_other_policy)}</span>
            </div>
            <div className="dialog-item">
              <strong>Patients:</strong> <span>{selectedItem.patients.map(n => n.name).join(", ")}</span>
<strong className="ml-6"> Apply To Other Patients:</strong> <span>{String(selectedItem.apply_to_other_patients)}</span>
</div>
          </div>
                                    <div className="dialog-row two-col-row">
                                        <div className="dialog-item">
                                            <strong>User Level:</strong> <span>{selectedItem.user_level.join(", ")}</span>
                                            <strong className="ml-6"> Apply To Other User Level:</strong> <span>{String(selectedItem.apply_to_other_user)}</span>
                                        </div>
                                        <div className="dialog-item">
                                            <strong>Apply To VIP:</strong> <span>{String(selectedItem.apply_to_vip)}</span>
                                        </div>
                                    </div>
                                </div>

                                <button className="dialog-close-btn" onClick={handleCloseDialog}>Close</button>
                            </div>
                        )}
                    </dialog>
                
            )}

      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {editIndex === null
                ? "Add Drug: Age and Gender"
                : "Edit Drug: Age and Gender"}
            </DialogTitle>
            </DialogHeader>
          <div className="grid grid-cols-2 gap-4 mt-4">
      {/* First Column */}
      <div>
      <div className="mb-4">

<Label htmlFor="custom_group_name">Relation Name</Label>
<Input
  id="custom_group_name"
  value={customGroupName}
  onChange={(e) => setCustomGroupName(e.target.value)}  

  placeholder="Relation Name is required  "
/>
</div>


<div className="mb-4">
<Label htmlFor="DrugCode">Drug Code:</Label>
<ListOfDrugCode
onChange={handleRelatedDrugChange}
defaultValue={DrugCode}  
clear={clearDrugCode}
/>
            </div>
                               

            <div className="mb-4">
            <Label htmlFor="DrugcustomGroups">Drug Custom Groups:</Label>
              <ListOfDrugCustom
                onChange={handleCustomDrugGroupsChange}
                defaultValue={customDrugGroups}
                clear={clearCustomDrugGroups}
              />

            </div>
            <div className="mb-3">
  <Label htmlFor="lower_age">Lower Age</Label>
  <Input
          id="lower_age"
          value={lowerAge ?? ""} 
          onChange={(e) => setLowerAge(e.target.value ? parseInt(e.target.value) : null)}
        />
</div>
      <div className="mb-4">
                 <Label>Providers:</Label>
                 <ListOfProviderName onChange={handleProviderChange} defaultValue={provider} clear={clearProvider} />
               </div>
       
               <div className="mb-4">
                 <Label>Networks:</Label>
                 <ListOfNewNetworkName onChange={handleNetworksChange}  defaultValue={networks}  clear={clearNetworks} />
                 </div>
       
               <div className="mb-4">
                 <Label>Insurance Plan:</Label>
                 <ListOfInsuranceplanName onChange={handleInsurancePlanChange}  defaultValue={insuranceplan}  clear={clearInsuranceplan} />
       
               </div>
               <div className="mb-4">
                 <Label> Payer:</Label>
                 <Input
                   value={Payer.join(",")}
                   onChange={(e) => setPayer([e.target.value])}
                   placeholder="Enter Payer"
                 />
               </div>
               <div className="mb-4">
                 <Label>Patients:</Label>
                  <Patient onChange={handlePatientChange} defaultValue={patients} clear={clearPatient} />
               </div>
               <div className="mb-4">
                             <Label>Policy:</Label>
          <PolicyNames onChange={handlePoliciesChange}  defaultValue={policy}  clear={clearPolicy} />
       
               </div>
               <div className="mb-4">
                 <Label>User Level:</Label>
                 <Input
                   value={userLevel.join(",")}
                   onChange={(e) => setUserLevel([e.target.value])}
                   placeholder="Enter User Level"
                 />
               </div>
                           
            
   
 </div>
      {/* Second Column */}
      <div>
      <div className="mb-3 w-80">
  <Accordion type="single" collapsible>
    <AccordionItem value="item-1">
      <AccordionTrigger>Gender:</AccordionTrigger>
      <AccordionContent>
     <div>
          <label>
            <input
              type="radio"
              name="gender"
              value="male"
              checked={gender === "male"}
              onChange={(e) => setGender(e.target.value)}
            />{" "}
            Male
          </label>
          <label className="ml-4">
            <input
              type="radio"
              name="gender"
              value="female"
              checked={gender === "female"}
              onChange={(e) => setGender(e.target.value)}
            />{" "}
            Female
          </label>
        </div>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
</div>


      <div className="mb-1">
      <Label htmlFor="DrugmedicalGroups">Drug Medical Groups:</Label>
              <ListOfDrugMedical
                onChange={handleMedicalDrugGroupsChange}
                defaultValue={medicalDrugGroups}
                clear={clearMedicalDrugGroups}
              />
            </div>
            <div className="mb-11 w-80">
        <Accordion type="single" collapsible>
  <AccordionItem value="item-1">
    <AccordionTrigger>Age Exclude:</AccordionTrigger>
    <AccordionContent>
    <div>
            <label>
              <input
                type="radio"
                name="age_exclude"
                value="true"
                checked={ageExclude === true}
                onChange={(e) => setAgeExclude(e.target.value === "true")}
              />{" "}
              True
            </label>
            <label className="ml-4">
              <input
                type="radio"
                name="age_exclude"
                value="false"
                checked={ageExclude === false}
                onChange={(e) => setAgeExclude(e.target.value === "true")}
              />{" "}
              False
            </label>
          </div>
    </AccordionContent>
  </AccordionItem>
</Accordion>
       
     
        </div>
          <div className="mb-">
  <Label htmlFor="higher_age">Higher Age</Label>
  <Input
          id="higher_age"
          value={higherAge ?? ""} 
          onChange={(e) => setHigherAge(e.target.value ? parseInt(e.target.value) : null)}
        />
</div>

         <div className="mb-3 w-80">
               <Accordion type="single" collapsible>
         <AccordionItem value="item-1">
           <AccordionTrigger>Apply To Other Providers?</AccordionTrigger>
           <AccordionContent>
           <div>
                   <label>
                     <input
                       type="radio"
                       name="Providers"
                       value="true"
                       checked={applyToOtherProviders === true}
                       onChange={(e) => setApplyToOtherProviders(e.target.value === "true")}
                     />{" "}
                     True
                   </label>
                   <label className="m-2">
                     <input
                       type="radio"
                       name="Providers"
                       value="false"
                       checked={applyToOtherProviders === false}
                       onChange={(e) => setApplyToOtherProviders(e.target.value === "true")}
                     />{" "}
                     False
                   </label>
                 </div>
           </AccordionContent>
         </AccordionItem>
       </Accordion>
              
               
               </div>
               <div className="mb-3 w-80">
               <Accordion type="single" collapsible>
         <AccordionItem value="item-1">
           <AccordionTrigger>Apply To Other Networks:</AccordionTrigger>
           <AccordionContent>
           <div>
                   <label>
                     <input
                       type="radio"
                       name="Networks"
                       value="true"
                       checked={apply_to_other_networks === true}
                       onChange={(e) => setApply_to_other_networks(e.target.value === "true")}
                     />{" "}
                     True
                   </label>
                   <label className="ml-4">
                     <input
                       type="radio"
                       name="Networks"
                       value="false"
                       checked={apply_to_other_networks === false}
                       onChange={(e) => setApply_to_other_networks(e.target.value === "true")}
                     />{" "}
                     False
                   </label>
                 </div>
           </AccordionContent>
         </AccordionItem>
       </Accordion>
              
               </div>
               <div className="mb-4 w-80">
               <Accordion type="single" collapsible>
         <AccordionItem value="item-1">
           <AccordionTrigger>Apply To Other Insurance Plan:</AccordionTrigger>
           <AccordionContent>
           <div>
                   <label>
                     <input
                       type="radio"
                       name="Insurance"
                       value="true"
                       checked={apply_to_other_insuranceplan === true}
                       onChange={(e) => setapply_to_other_insuranceplan(e.target.value === "true")}
                     />{" "}
                     True
                   </label>
                   <label className="ml-4">
                     <input
                       type="radio"
                       name="Insurance"
                       value="false"
                       checked={apply_to_other_insuranceplan === false}
                       onChange={(e) => setapply_to_other_insuranceplan(e.target.value === "true")}
                     />{" "}
                     False
                   </label>
                 </div>
           </AccordionContent>
         </AccordionItem>
       </Accordion>
              
               
               </div>
               <div className="mb-4 w-80">
               <Accordion type="single" collapsible>
         <AccordionItem value="item-1">
           <AccordionTrigger>Apply To Other Payer:</AccordionTrigger>
           <AccordionContent>
           <div>
                   <label>
                     <input
                       type="radio"
                       name="Payer"
                       value="true"
                       checked={apply_to_other_payer === true}
                       onChange={(e) => setapply_to_other_payer(e.target.value === "true")}
                     />{" "}
                     True
                   </label>
                   <label className="ml-4">
                     <input
                       type="radio"
                       name="Payer"
                       value="false"
                       checked={apply_to_other_payer === false}
                       onChange={(e) => setapply_to_other_payer(e.target.value === "true")}
                     />{" "}
                     False
                   </label>
                 </div>
           </AccordionContent>
         </AccordionItem>
       </Accordion>
              
               
               </div>
               <div className="mb-3 w-80">
               <Accordion type="single" collapsible>
         <AccordionItem value="item-1">
           <AccordionTrigger>Apply To Other Patients:</AccordionTrigger>
           <AccordionContent>
           <div>
                   <label>
                     <input
                       type="radio"
                       name="Patients"
                       value="true"
                       checked={apply_to_other_patients === true}
                       onChange={(e) => setApply_to_other_patients(e.target.value === "true")}
                     />{" "}
                     True
                   </label>
                   <label className="ml-4">
                     <input
                       type="radio"
                       name="Patients"
                       value="false"
                       checked={apply_to_other_patients === false}
                       onChange={(e) => setApply_to_other_patients(e.target.value === "true")}
                     />{" "}
                     False
                   </label>
                 </div>
           </AccordionContent>
         </AccordionItem>
       </Accordion>
              </div>
             <div className="mb-3 w-80">
                                        <Accordion type="single" collapsible>
                                             <AccordionItem value="item-1">
                                                <AccordionTrigger>Apply To Other Policy:</AccordionTrigger>
                                       <AccordionContent>
                                                <div>
                                                <label>
                                                  <input
                                                type="radio"
                                                 name="Policy"
                                              value="true"
                                                checked={apply_to_other_policy === true}
                                                 onChange={(e) => setApply_to_other_policy(e.target.value === "true")}
                                                       />{" "}
                                                     True
                                                </label>
                                                <label className="ml-4">
                                                  <input
                                                      type="radio"
                                                      name="Policy"
                                                            value="false"
                                                         checked={apply_to_other_policy === false}
                                                               onChange={(e) => setApply_to_other_policy(e.target.value === "true")}
                                                                 />{" "}
                                                                             False
                                                                         </label>
                                                                    </div>
                                                                    </AccordionContent>
                                                                    </AccordionItem>
                                                                      </Accordion>
                                          </div>
              <div className="mb-3 w-80">
               <Accordion type="single" collapsible>
         <AccordionItem value="item-1">
           <AccordionTrigger>Apply To Other User:</AccordionTrigger>
           <AccordionContent>
           <div>
                   <label>
                     <input
                       type="radio"
                       name="user"
                       value="true"
                       checked={apply_to_other_user === true}
                       onChange={(e) => setApply_to_other_user(e.target.value === "true")}
                     />{" "}
                     True
                   </label>
                   <label className="ml-4">
                     <input
                       type="radio"
                       name="user"
                       value="false"
                       checked={apply_to_other_user === false}
                       onChange={(e) => setApply_to_other_user(e.target.value === "true")}
                     />{" "}
                     False
                   </label>
                 </div>
           </AccordionContent>
         </AccordionItem>
       </Accordion>
              </div>
              <div className="mb-3 w-80">
               <Accordion type="single" collapsible>
         <AccordionItem value="item-1">
           <AccordionTrigger>Apply To Vip:</AccordionTrigger>
           <AccordionContent>
           <div>
                   <label>
                     <input
                       type="radio"
                       name="Vip"
                       value="true"
                       checked={apply_to_other_vip === true}
                       onChange={(e) => setApply_to_other_vip(e.target.value === "true")}
                     />{" "}
                     True
                   </label>
                   <label className="ml-4">
                     <input
                       type="radio"
                       name="Vip"
                       value="false"
                       checked={apply_to_other_vip === false}
                       onChange={(e) => setApply_to_other_vip(e.target.value === "true")}
                     />{" "}
                     False
                   </label>
                 </div>
           </AccordionContent>
         </AccordionItem>
       </Accordion>
              </div>
       </div>
 
    </div>
         
<DialogFooter className="gap-2 m-4">
            <Button
              onClick={() => {
                if (editIndex === null) {
                  addItem();
                } else {
                  updateItem(editIndex);
                }
              }}
              className="bg-blue-600 hover:bg-blue-700"
            >
              {editIndex === null ? "Add Relation " : "Update Relation "}
            </Button>
            <Button
              variant="outline"
             
                onClick={(e) => { 
                  setEditIndex(null);
                   clear(); 
                  setIsDialogOpen(false);
                 }}
            >
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>


      <Toaster />
    </div>
  );
};

export default DragAgeAndGender;
